import styled from 'styled-components';

export const MainContainer = styled.div`
  height: 100%;
  width: auto;
  margin-top :10px;
  margin-left: ${(props) =>
    !props.active ? '28px' : '115px'};
  padding: ${(props) =>
    !props.active ? '200px' : 'calc(var(--na v-width) + 2rem)'};
  transition: .0s;
  padding-top: calc(var(--header-height) + 2rem);
  padding-right: 20px;
  @media only screen and (max-width: 768px) {
    padding: ${(props) => (props.active ? '8px' : 'auto')};
    padding-top: 50px;
  
  }
`;